<template>
  <div class="modal-card v-custorm-body">
    <header class="modal-card-head is-small">
      <p class="modal-card-title">{{ title }}</p>
      <span class="v-icon-close" @click="$emit('close')">
        <b-icon size="is-medium" pack="fa" icon="window-close"> </b-icon>
      </span>
    </header>
    <section class="modal-card-body v-custorm-body">
      <div class="columns" style="margin-top: 5px">
        <div class="column">
          <b-field
            label="オークション会場"
            expanded
            :type="errType.transportFrom"
            :message="errMsg.transportFrom"
          >
            <b-autocomplete
              :data="filteredAuctionSiteList"
              field="E_AuctionAreaSatellite.value"
              v-model="auctionVendorInput"
              @select="setAuctionVendor"
              open-on-focus
              clearable
            ></b-autocomplete>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            label="納車-提携ヤード"
            expanded
            :type="errType.yardVendor"
            :message="errMsg.yardVendor"
          >
            <b-autocomplete
              :data="filteredYardVendors"
              field="AREA_NAME.value"
              v-model="yardVendorInput"
              @select="setYardName"
              open-on-focus
              clearable
            >
            </b-autocomplete>
          </b-field>
        </div>
      </div>

      <!-- START QuocNV 20230703 add new field hadling company in popup -->
      <div class="columns">
        <div class="column">
          <b-field label="HANDLING COMPANY(JP)" expanded>
            <b-input v-model="item.handlingCompanyJp">
            </b-input>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="HANDLING COMPANY(EN)" expanded>
            <b-input
              v-model="item.handlingCompanyEn"></b-input>
          </b-field>
        </div>
      </div>
      <!-- END QuocNV 20230703 add new field hadling company in popup -->

      <div class="columns">
        <div class="column">
          <b-field
            label="陸送会社"
            v-if="filteredTransportCosts.length > 0"
            :type="errType.transportCost"
            :message="errMsg.transportCost"
          >
            <b-autocomplete
              key="item.transportOptionNumberPlateCut"
              :data="filteredTransportCosts"
              field="vendorName"
              v-model="transportVendorInput"
              @select="setTransportCost"
              :loading="isFetching"
              placeholder="ヤードを選択して下さい"
              open-on-focus
              clearable
            >
              <template slot-scope="props">
                {{ props.option.vendorName }} ({{ props.option.id }})
                <br />
                <small>
                  {{ props.option.totalActualCost | formatNumber }}
                </small>
                <small class="has-text-grey-light">
                  ( actual: {{ props.option.actualCost | formatNumber }}, out:
                  {{ props.option.outFee | formatNumber }}, cut:
                  {{ props.option.numberPlateCutFee | formatNumber }}, base:
                  {{ props.option.cost | formatNumber }}, a:
                  {{ props.option.costA | formatNumber }}, b:
                  {{ props.option.costB | formatNumber }}, c:
                  {{ props.option.costC | formatNumber }}, d:
                  {{ props.option.costD | formatNumber }}, e:
                  {{ props.option.costE | formatNumber }}
                  )
                </small>
              </template>
            </b-autocomplete>
          </b-field>
          <b-field
            label="陸送会社"
            v-else
            :type="errType.transportCost"
            :message="errMsg.transportCost"
          >
            <b-autocomplete
              key="0"
              :data="filteredTransportVendors"
              field="Company.value"
              :loading="isFetching"
              v-model="transportVendorInput"
              @select="setTransportVendor"
              open-on-focus
              clearable
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="陸送会社への連絡事項" expanded>
            <b-input type="textarea" v-model="item.transportRemarks"></b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-button @click="showCalendar">搬入期限の依頼補記</b-button>
          <b-datepicker
            v-if="isShow"
            :inline="true"
            v-model="deliveryDeadline"
            @input="updateDeliveryDeadline"
            size="is-small"
          >
          </b-datepicker>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="陸送費（実費）"
              :type="errType.errCost"
              :message="errMsg.msgCost">
            <b-input v-model="item.transportActualCost"
                    @input="validationInput"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="陸送費（請求）"
              :type="errType.errTransportCost"
              :message="errMsg.msgTransportCost">
            <b-input v-model="item.transportCost"
                    @input="validationInput"></b-input>
          </b-field>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <span></span>
      <div>
        <b-button label="クリア" class="v-btn-clear" @click="clear" />
        <b-button label="登録" class="v-btn-save" @click="save" />
      </div>
    </footer>
  </div>
</template>
<style scoped>
.v-custorm-body {
  width: 570px;
  height: 505px;
}
::v-deep .modal-card-head {
  padding-right: 10px;
  height: 50px;
}
::v-deep .modal-card-foot {
  display: flex;
  justify-content: space-between;
  height: 60px;
}
.v-icon-close {
  cursor: pointer;
}
.v-btn-save {
  background-color: #0062b2;
  border-radius: 5px;
  color: #ffffff;
  width: 90px;
  height: 37px;
}
.v-btn-save:hover {
  background-color: #e39400;
}
.v-btn-clear {
  background-color: #f0f3f5;
  border-radius: 5px;
  color: black;
  width: 90px;
  height: 37px;
}
.v-btn-clear:hover {
  background-color: #cbd0d4;
}
</style>
<script>
import moment from 'moment';
import transportVendorRepository from '@/repositories/transportVendor';
const constDeliveryString = '※MM/ddまでの搬入をお願いします。';
const DATE_FORMAT = 'YYYY-MM-DD';
const regexFormatNumber = /^[0-9]+$/;
export default {
  props: [
    'title',
    'handler',
    'auctions',
    'yards',
    'transportVendors',
    'transportFromId',
    'transportFromName',
    'fromYardPlace',
    'customerId',
    'customerGrade'
  ],
  data: () => ({
    date: new Date(),
    isSaving: false,
    transportFrom: '',
    auctionVendorInput: '',
    yardVendorInput: '',
    transportVendorInput: '',
    transportCosts: [],
    selectedAuctionVendor: null,
    isShow: false,
    deliveryDeadline: null,
    isFetching: false,
    item: {
      transportRemarks: '',
    },
    errType: {
      transportFrom: '',
      yardVendor: '',
      transportCost: '',
      errCost:'',
      errTransportCost: '',

    },
    errMsg: {
      transportFrom: '',
      yardVendor: '',
      transportCost: '',
      msgCost: '',
      msgTransportCost: '',
    },
  }),
  computed: {
    filteredAuctionSiteList() {
      return this.auctions.filter(
        (option) =>
          option.E_AuctionAreaSatellite.value
            .toUpperCase()
            .indexOf(this.auctionVendorInput.toUpperCase()) >= 0
      );
    },
    filteredYardVendors() {
      return this.yards.filter(
        (option) =>
          option.AREA_NAME.value
            .toUpperCase()
            .indexOf(this.yardVendorInput.toUpperCase()) >= 0
      );
    },
    transportCostsWithExtraFees() {
      return this.transportCosts
        .map((c) => {
          c.numberPlateCutFee = 0;
          const vendor = this.transportVendors.find(
            (v) => v.TransporterID.value == c.vendorId
          );
          c.outFee = this.calcTransportOutFee(
            c.vendorId,
            this.selectedAuctionVendor
          );
          c.numberPlateCutFee = +vendor.NumberPlateCutFee.value || 0;
          c.totalActualCost = c.actualCost + c.outFee + c.numberPlateCutFee;
          return c;
        })
        .sort((a, b) => {
          let x = a.actualCost + a.outFee;
          let y = b.actualCost + b.outFee;
          if (this.item.transportOptionNumberPlateCut) {
            x += a.numberPlateCutFee;
            y += b.numberPlateCutFee;
          }
          return x > y ? 1 : -1;
        });
    },
    filteredTransportVendors() {
      return this.transportVendors.filter(
        (option) =>
          option.Company.value
            .toUpperCase()
            .indexOf(this.transportVendorInput.toUpperCase()) >= 0
      );
    },
    filteredTransportCosts() {
      return this.transportCostsWithExtraFees.filter(
        (option) =>
          option.vendorName
            .toUpperCase()
            .indexOf(this.transportVendorInput.toUpperCase()) >= 0
      );
    },
  },
  async created() {
    this.isFetching = false;
    this.item.transportFromId = this.transportFromId;
    this.item.transportFromName = this.transportFromName;
    this.auctionVendorInput = this.transportFromName;
    //START QuocNV 20230703 add new field when transport 2++
    this.item.fromYardPlace = this.fromYardPlace;
    this.item.customerId  = this.customerId;
    this.item.customerGrade = this.customerGrade;
    //END QuocNV 20230703 add new field when transport 2++
  },
  methods: {
    setAuctionVendor(auction) {
      this.errType.transportFrom = '';
      this.errMsg.transportFrom = '';
      this.item.transportFromId = auction ? auction.AA_ID.value : '';
      this.item.transportFromName = auction
        ? auction.AuctionAreaSatellite.value
        : '';
      //START QuocNV 20230703 add new from yard place to yard when transport 2++
      this.item.fromYardPlace = null;
      //END QuocNV 20230703 add new from yard place to yard when transport 2++
      this.auctionVendorChanged(auction);
    },
    auctionVendorChanged(auction) {
      this.selectedAuctionVendor = auction;
      this.item.yardTransportId = auction ? auction.AA_ID.value : '';
      this.item.yardTransportName = auction
        ? auction.AuctionAreaSatellite.auction
        : '';
      this.item.yardAdressTransport = auction ? auction.Address.value : '';
      this.item.yardAreaTransport = auction ? auction.Big_Area.value : '';
    },
    setYardName(yard) {
      if (!yard) {
        this.setTransportCost(null);
      }
      this.yardVendorInput = yard ? yard.AREA_NAME.value : '';
      this.item.transportToId = yard ? yard.AREA_NAME.value : '';
      this.item.transportToName = yard ? yard.YardName.value : '';
      this.item.transportToAddress = yard ? yard.Address.value : '';
      this.item.transportToArea = yard ? yard.AREA.value : '';
      this.item.transportToRemarks = yard
        ? yard.Delivery_Confirmation.value
        : '';
      this.item.transportToPhone = yard ? yard.Telephone.value : '';
      this.item.transportToIncharge = yard ? yard.Incharge.value : '';
      // START QuocNV add-New Item HandlingCompany
      if (yard) {
        if (yard.Yard_Category.value == '1'){
        this.item.yardId = yard.Yard_Record_Id.value;
        } else {
        this.item.yardId = yard.Yard_City.value;
        }
      } else {
        this.item.yardId = '';
      }
      this.item.yardIdTemp = yard ? yard.Yard_Record_Id.value : '';
      this.item.handlingCompanyEn = yard ? yard.handling_company_en.value : '';
      this.item.handlingCompanyJp = yard ? yard.handling_company_jp.value : '';
      this.item.yardCategory = yard ? yard.Yard_Category.value : '';
      // END QuocNV add-New Item HandlingCompany
      this.calc();
      this.errType.yardVendor = '';
      this.errMsg.yardVendor = '';
    },
    async calc() {
      this.transportCosts = [];
      this.isFetching = true;
      if (
        this.item.transportFromId == '' ||
        this.item.transportToArea == '' ||
        this.item.fromYardPlace == null || this.item.fromYardPlace == -1 || this.item.fromYardPlace ==''||
        this.item.customerId == '' || this.item.yardId ==''
      ) {
        this.isFetching = false;
        return;
      }
      //START QUOCNV 20230529 add new feature get value yard to yard
      let placeYardType = '1';
      if (this.item.yardCategory=='1') {
        placeYardType = '2';
      } 
      //END QUOCNV 20230529 add new feature get value yard to yard
      const actualCosts = await transportVendorRepository.getActualCostsFromJC(
        -1,-1,
        this.item.yardId,
        this.item.fromYardPlace,
        placeYardType
      );
      const costs = await transportVendorRepository.getCostsFromJC(
        -1,
        -1,
        this.item.yardId,
        this.item.customerId,
        this.item.fromYardPlace,
        placeYardType
      );
      this.transportCosts = actualCosts.map((cost) => ({
        id: cost.TransportCostID.value,
        actualCost: +cost.Actual_Cost.value,
        cost: costs.length > 0 ? costs[0].base : 0,
        costA: costs.length > 0 ? costs[0].base + costs[0].a : 0,
        costB: costs.length > 0 ? costs[0].base + costs[0].b : 0,
        costC: costs.length > 0 ? costs[0].base + costs[0].c : 0,
        costD: costs.length > 0 ? costs[0].base + costs[0].d : 0,
        costE: costs.length > 0 ? costs[0].base + costs[0].e : 0,
        costF: costs.length > 0 ? costs[0].base + costs[0].f : 0,
        vendorId: cost.TransporterID.value,
        vendorName: (cost.TransporterNameE.value != null) ? cost.TransporterNameE.value : '',
      }));
      this.isFetching = false;
    },
    updateDeliveryDeadline() {
      this.item.transportEstimatedArrivalDate = moment(
        this.deliveryDeadline,
        DATE_FORMAT
      ).toDate();
      this.isShow = !this.isShow;
      const regex = /(※.*?。)/;
      const splitItems = this.item.transportRemarks.split(regex);
      let arr = [];
      for (let i = 0; i < splitItems.length; i++) {
        if (regex.test(splitItems[i])) {
          arr.push(splitItems[i]);
        }
      }
      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          this.item.transportRemarks = this.item.transportRemarks.replace(
            arr[i],
            constDeliveryString.replace(
              'MM/dd',
              moment(this.deliveryDeadline).format('MM/DD')
            )
          );
        }
      } else {
        this.item.transportRemarks =
          this.item.transportRemarks +
          '\r\n' +
          String(constDeliveryString).replace(
            'MM/dd',
            moment(this.deliveryDeadline).format('MM/DD')
          );
      }
    },
    setTransportCost(cost) {
      this.selectedCost = cost;
      this.transportVendorInput = cost ? cost.vendorName : '';
      this.item.transportPlan = cost ? this.item.customerGrade : '';

      this.item.transportPlanFee = cost ? +cost['cost'.concat(this.item.customerGrade)] : 0;

      // this.item.transportPlanFee = cost ? +cost.costA : 0;
      this.item.transportVendorId = cost ? cost.vendorId : '';
      this.item.transportVendorName = cost ? cost.vendorName : '';
      this.item.transportCostId = cost ? cost.id : '';
      this.item.transportActualCost = cost ? +cost.actualCost : 0;
      this.item.transportOutFee = this.calcTransportOutFee(
        this.item.transportVendorId,
        this.selectedAuctionVendor
      );
      this.item.transportNumberPlateCutFee =
        cost && this.item.transportOptionNumberPlateCut
          ? cost.numberPlateCutFee
          : 0;
      this.item.transportCost = cost ? +cost['cost'.concat(this.item.customerGrade)] : 0;
      this.calcTotalCost();
      this.errType.transportCost = '';
      this.errMsg.transportCost = '';
    },
    setTransportVendor(vendor) {
      this.selectedVendor = vendor;
      this.transportVendorInput = vendor ? vendor.Company.value : '';
      this.item.transportVendorId = vendor ? vendor.TransporterID.value : '';
      this.item.transportVendorName = vendor ? vendor.Company.value : '';
      this.item.transportOutFee = this.calcTransportOutFee(
        this.item.transportVendorId,
        this.selectedAuctionVendor
      );
      this.item.transportNumberPlateCutFee =
        vendor && this.item.transportOptionNumberPlateCut
          ? +vendor.NumberPlateCutFee.value
          : 0;
      this.calcTotalCost();
      this.errType.transportCost = '';
      this.errMsg.transportCost = '';
    },
    calcTransportOutFee(vendorId, from) {
      if (!vendorId || !from) return 0;
      if (
        from.AA_ID.value.startsWith('LUM') &&
        vendorId != 'e422e8a0-4c7f-4f5d-88fe-22be7cf2ad69' //LOGICO
      ) {
        return 1500;
      }
      return 0;
    },
    calcTotalCost() {
      const totalActualCost =
        +this.item.transportActualCost +
        +this.item.transportOutFee +
        +this.item.transportNumberPlateCutFee;
      const totalCost =
        +this.item.transportCost + +this.item.transportNumberPlateCutFee;
      this.item.transportTotalActualCost = !isNaN(totalActualCost)
        ? totalActualCost
        : 0;
      this.item.transportTotalCost = !isNaN(totalCost) ? totalCost : 0;
    },
    async clear() {
      this.yardVendorInput = '';
      this.transportVendorInput = '';
      this.deliveryDeadline = '';
      this.item.transportRemarks = '';
      this.item.transportActualCost = 0;
      this.item.transportCost = 0;
    },
    async save() {
      this.isSaving = false;
      this.validateInput();
      if (this.isSaving) {
        return;
      }
      await this.handler(this.item);
      this.$emit('close');
    },
    showCalendar() {
      this.isShow = !this.isShow;
    },
    validateInput() {
      if (this.auctionVendorInput == '') {
        this.isSaving = true;
        this.errType.transportFrom = 'is-danger';
        this.errMsg.transportFrom = '「オークション会場」は必須です。';
      } else {
        this.errType.transportFrom = '';
        this.errMsg.transportFrom = '';
      }
      if (this.yardVendorInput == '') {
        this.isSaving = true;
        this.errType.yardVendor = 'is-danger';
        this.errMsg.yardVendor = '「納車-提携ヤード」は必須です。';
      } else {
        this.errType.yardVendor = '';
        this.errMsg.yardVendor = '';
      }
      if (this.transportVendorInput == '') {
        this.isSaving = true;
        this.errType.transportCost = 'is-danger';
        this.errMsg.transportCost = '「陸送会社」は必須です。';
      } else {
        this.errType.transportCost = '';
        this.errMsg.transportCost = '';
      }
      this.item.transportActualCost = String(this.item.transportActualCost)
        .replace('.', '')
        .replace(',', '');
      this.item.transportCost = String(this.item.transportCost)
        .replace('.', '')
        .replace(',', '');
      if (regexFormatNumber.test(this.item.transportActualCost)) {
        this.errType.errCost = '';
        this.errMsg.msgCost = '';
        this.calcTotalCost();
      } else {
        this.errType.errCost = 'is-danger';
        this.errMsg.msgCost =
          '数字以外の文字が入力されています。数字以外は「,」のみ有効です。';
      }
      if (regexFormatNumber.test(this.item.transportCost)) {
        this.errType.errTransportCost = '';
        this.errMsg.msgTransportCost = '';
        this.calcTotalCost();
      } else {
        this.errType.errTransportCost = 'is-danger';
        this.errMsg.msgTransportCost =
          '数字以外の文字が入力されています。数字以外は「,」のみ有効です。';
      }
    },
  },
};
</script>
